import React, {useState} from 'react';
import styled from 'styled-components';

import Row from "./../../../common/components/Row.js";
import Col from "./../../../common/components/Col.js";
import Card from "./../../../common/components/Card.js";
import Button from "./../../../common/components/Button.js";
import Typo from "./../../../common/components/Typo.js";
import Input from "./../../../common/components/Input.js";

const Error = styled.div.withConfig({displayName:'-Error'})`
  height: 30px;
  color: red;
`;

const FormSetName = ({onConfirm, error}) => {
  const [givenName, setGivenName] = useState('');
  const [familyName, setFamilyName] = useState('');


  return (

    <Card>
      <Typo variant="h1">Set name</Typo><br/>
      <>Enter your names.</>

      <Row>
        <Col widthmd="6">
          <Input
            label={"Given Name"}
            name="givenName"
            type="text"
            width="100%"
            value={givenName}
            onChange={(val) => setGivenName(val)}
            required
          />
        </Col>
        <Col widthmd="6">
          <Input
            label={"Family Name"}
            name="familyName"
            type="text"
            width="100%"
            value={familyName}
            onChange={(val) => setFamilyName(val)}
            required
          />
        </Col>
        <Col widthmd="12">
          <Button onClick={() => onConfirm({
            action: "set-name",
            params: {
              givenName: givenName,
              familyName: familyName
            }
          })}>Save</Button>
        </Col>
        <Col widthmd="12">
          <Error>
            <br/>{error}<br/>
          </Error>
        </Col>
      </Row>
    </Card>
  )
}

export default FormSetName;
